/** Aceita tamanho único (ex: 6) ou múltiplos separados por vírgula (ex: 5,6,10) ou range (ex: 1-12). */
export default function ()
{
	return {
		regex: /^(\d+)([\s,]\s*\d+)*$|^(\d+)\s*-\s*(\d+)$/,
		filter: /[\s]/g,
		store_mask: '$&',
		display_mask: '$&',
	};
}
